import { type BaseNotificationItemProps, NotificationItem } from '../components/NotificationItem'

export type EngagementProps = BaseNotificationItemProps & {
  systemName: string
  status: 'rejected' | 'closedWithTimeoutResponse'
  targetEntityId: string
  programName: string
  type: 'engagement'
}

const statusText = {
  rejected: 'rejected',
  closedWithTimeoutResponse: 'closed with timeout response',
} as const

export function Engagement({ systemName, status, programName, targetEntityId, ...props }: EngagementProps) {
  return (
    <NotificationItem
      {...props}
      title={`Engagement from ${systemName} ${statusText[status]}`}
      subTitle={targetEntityId}
      descriptionAddon={<p className='flex text-sm text-gray-500'>{programName}</p>}
    />
  )
}
